import { useAuth } from "../../../auth/useAuth";

const PropertyAdminPanel = ({ admin }) => {
  const { hasAnyPermission } = useAuth();
  const canView =
    hasAnyPermission(["real_estate.listings.view"]) && admin;

  if (!canView) {
    return null;
  }

  return (
    <section className="property-detail-section property-detail-admin" aria-label="Admin notes">
      <h2 className="property-detail-section__title">Admin</h2>

      {admin.staleListingWarning ? (
        <p className="property-detail-admin__warning">{admin.staleListingWarning}</p>
      ) : null}
      {admin.duplicateReviewHint ? (
        <p className="property-detail-admin__warning">{admin.duplicateReviewHint}</p>
      ) : null}

      <dl className="property-detail-attributes property-detail-attributes--cols-2">
        {admin.reviewStatus ? (
          <div>
            <dt>Review status</dt>
            <dd>{admin.reviewStatus}</dd>
          </div>
        ) : null}
        {admin.canonicalStatus ? (
          <div>
            <dt>Canonical status</dt>
            <dd>{admin.canonicalStatus}</dd>
          </div>
        ) : null}
        {admin.qualityScore != null ? (
          <div>
            <dt>Quality score</dt>
            <dd>{admin.qualityScore}</dd>
          </div>
        ) : null}
        {admin.matchConfidenceScore != null ? (
          <div>
            <dt>Match confidence</dt>
            <dd>{admin.matchConfidenceScore}%</dd>
          </div>
        ) : null}
      </dl>

      {admin.internalNotes ? <p>{admin.internalNotes}</p> : null}

      {admin.sourceDebugSummary?.length ? (
        <>
          <h3>Linked sources (debug)</h3>
          <ul className="property-detail-admin__sources">
            {admin.sourceDebugSummary.map((entry) => (
              <li key={entry.propertyId}>
                <strong>{entry.displaySource || entry.source}</strong>
                {entry.detailUrl ? (
                  <>
                    {" "}
                    <a href={entry.detailUrl} target="_blank" rel="noreferrer">
                      Raw source
                    </a>
                  </>
                ) : null}
                {entry.lastSeenAt ? ` · ${new Date(entry.lastSeenAt).toLocaleString()}` : ""}
              </li>
            ))}
          </ul>
        </>
      ) : null}

      {admin.adminCanonicalUrl ? (
        <a href={admin.adminCanonicalUrl} className="midpoint-share-button">
          Open in Admin
        </a>
      ) : null}
    </section>
  );
};

export default PropertyAdminPanel;
